var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0162 2.57606C20.2533 2.92348 19.4319 3.15842 18.5703 3.2634C19.4502 2.72352 20.1253 1.86747 20.4434 0.847698C19.6196 1.34759 18.7092 1.71125 17.7367 1.90621C16.9616 1.05765 15.8538 0.527771 14.6278 0.527771C12.277 0.527771 10.3697 2.48358 10.3697 4.89553C10.3697 5.23795 10.4063 5.57038 10.4794 5.8903C6.93914 5.70785 3.80102 3.97074 1.69878 1.32509C1.33196 1.97244 1.12234 2.72352 1.12234 3.52334C1.12234 5.038 1.87427 6.3752 3.0174 7.15877C2.32031 7.13752 1.66222 6.93882 1.087 6.61389V6.66763C1.087 8.78465 2.55552 10.5505 4.50542 10.9504C4.14835 11.0529 3.77177 11.1041 3.38301 11.1041C3.1088 11.1041 2.84069 11.0779 2.58111 11.0266C3.12343 12.7612 4.69554 14.0247 6.56013 14.0585C5.10258 15.2307 3.2648 15.9293 1.2698 15.9293C0.926134 15.9293 0.58612 15.9093 0.253418 15.8693C2.13873 17.1065 4.37868 17.8301 6.78315 17.8301C14.6193 17.8301 18.903 11.1754 18.903 5.40292C18.903 5.21296 18.8993 5.023 18.892 4.83679C19.7244 4.22068 20.4471 3.45211 21.0162 2.57606Z",
    fill: "#0081FE",
    fillOpacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.da504b2ce75ac9bca7473d32292199cd.svg";
export { ForwardRef as ReactComponent };